// dependencies
import React from "react";
import { List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// components
import Dropzone from "react-dropzone";
import Button from "Components/Button";
import Text from "Components/Inputs/Text";
import Textarea from "Components/Inputs/Textarea";
import { XCircle } from "lucide-react";

// config
import Config from "Config";

// actions
import { init, changeInput, sendBugReport, uploadScreenshot, removeScreenshot } from "./actions";

// selectors
import { getFileList, getInputValue } from "./selectors";

// css
import css from "./Page";

class Page extends React.PureComponent {
	static propTypes = {
		init: PropTypes.func.isRequired,
		uploadScreenshot: PropTypes.func.isRequired,
		removeScreenshot: PropTypes.func.isRequired,
		changeInput: PropTypes.func.isRequired,
		sendBugReport: PropTypes.func.isRequired,
		requestID: PropTypes.string.isRequired,
		whatIDid: PropTypes.string.isRequired,
		whatHappened: PropTypes.string.isRequired,
		whatIExpected: PropTypes.string.isRequired,
		fileList: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {};

	componentDidMount = () => {
		this.props.init();
	};

	handleDrop = (acceptedFiles) => {
		acceptedFiles.forEach((file) => {
			this.props.uploadScreenshot(file);
		});
	};

	handleRemoveScreenshot = (fileID) => {
		this.props.removeScreenshot(fileID);
	};

	handleChange = (name, value) => {
		this.props.changeInput(name, value);
	};

	handleCreate = () => {
		this.props.sendBugReport();
	};

	render = () => {
		const { fileList, requestID, whatIDid, whatHappened, whatIExpected } = this.props;

		return (
			<div className={css.Main}>
				<div className={css.formWrapper}>
					<div className={css.inputContainer}>
						<div className={css.label}>Request ID:</div>
						<Text value={requestID} onChange={(value) => this.handleChange("requestID", value)} />
					</div>

					<div className={css.inputContainer}>
						<div className={css.label}>What I did:</div>
						<Textarea value={whatIDid} onChange={(value) => this.handleChange("whatIDid", value)} />
					</div>

					<div className={css.inputContainer}>
						<div className={css.label}>What I expected:</div>
						<Textarea
							value={whatIExpected}
							onChange={(value) => this.handleChange("whatIExpected", value)}
						/>
					</div>

					<div className={css.inputContainer}>
						<div className={css.label}>What actually happened:</div>
						<Textarea value={whatHappened} onChange={(value) => this.handleChange("whatHappened", value)} />
					</div>

					<div className={`${css.inputContainer} ${css.imageContainer}`}>
						<div className={css.label}>Screenshots:</div>

						<div className={css.uploadedScreenshots}>
							{fileList.map((file) => (
								<div className={css.screenshot}>
									<img
										key={file}
										alt={file}
										src={`${Config.APIHost}/bug-report/screenshot/${file}`}
									/>
									<div
										onClick={() => this.handleRemoveScreenshot(file)}
										className={css.removeScreenshot}
									>
										<XCircle size={16} />
									</div>
								</div>
							))}
						</div>

						<Dropzone className={css.dropZone} acceptClassName={css.activeDrop} onDrop={this.handleDrop}>
							<div className={css.dropText}>Drop Screenshots</div>
						</Dropzone>
					</div>

					<div className={css.inputContainer}>
						<Button onClick={this.handleCreate}>Create Bug Report</Button>
					</div>
				</div>
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	fileList: getFileList(state),
	whatIDid: getInputValue(state, "whatIDid"),
	requestID: getInputValue(state, "requestID"),
	whatHappened: getInputValue(state, "whatHappened"),
	whatIExpected: getInputValue(state, "whatIExpected"),
});

const mapDispatchToProps = (dispatch) => ({
	init: () => dispatch(init()),
	sendBugReport: () => dispatch(sendBugReport()),
	uploadScreenshot: (file) => dispatch(uploadScreenshot(file)),
	removeScreenshot: (fileID) => dispatch(removeScreenshot(fileID)),
	changeInput: (name, value) => dispatch(changeInput(name, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page);
